import { PDF_PROCESSING_ENDPOINTS } from './endpoints.js';
/**
 * PDF Processing API Client
 * Encapsulates all PDF processing-related API calls.
 */
export class PdfProcessingClient {
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    /**
     * Initiates the PDF processing workflow to get a presigned URL for uploading.
     * Corresponds to: POST /api/pdf-processing/initiate-processing
     */
    async initiateProcessing(request) {
        const response = await this.httpClient.post(PDF_PROCESSING_ENDPOINTS.INITIATE, request);
        return response.data;
    }
    /**
     * Polls for the current status of a processing job.
     * Corresponds to: GET /api/pdf-processing/status/:jobId
     */
    async getStatus(jobId) {
        const response = await this.httpClient.get(`${PDF_PROCESSING_ENDPOINTS.GET_STATUS}/${jobId}`);
        return response.data;
    }
    /**
     * Retrieves a presigned URL for downloading the result of a processed job.
     * Corresponds to: GET /api/pdf-processing/result-url/:jobId
     */
    async getResultUrl(jobId) {
        const response = await this.httpClient.get(`${PDF_PROCESSING_ENDPOINTS.GET_RESULT_URL}/${jobId}`);
        return response.data;
    }
    /**
     * Confirms that the client has successfully downloaded the result file.
     * Corresponds to: POST /api/pdf-processing/confirm-download/:jobId
     */
    async confirmDownload(jobId) {
        await this.httpClient.post(`${PDF_PROCESSING_ENDPOINTS.CONFIRM_DOWNLOAD}/${jobId}`);
    }
    /**
     * Reports that the client failed to download the result file.
     * Corresponds to: POST /api/pdf-processing/report-download-failure/:jobId
     */
    async reportDownloadFailure(jobId) {
        await this.httpClient.post(`${PDF_PROCESSING_ENDPOINTS.REPORT_DOWNLOAD_FAILURE}/${jobId}`);
    }
    /**
     * Cancels a PDF processing job before it has been processed.
     * Corresponds to: POST /api/pdf-processing/cancel-job/:jobId
     */
    async cancelJob(jobId) {
        await this.httpClient.post(`${PDF_PROCESSING_ENDPOINTS.CANCEL_JOB}/${jobId}`);
    }
}
//# sourceMappingURL=client.js.map